import React from 'react';
import { YoutubeIcon, InstagramIcon, TwitterIcon, CheckIcon } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  position: string;
  imageSrc?: string;
  socialType?: 'youtube' | 'instagram' | 'twitter';
  socialCount?: string;
  socialLink?: string;
  showVerification?: boolean;
  className?: string;
}
export const TestimonialCard: React.FC<TestimonialProps> = ({
  quote,
  author,
  position,
  imageSrc,
  socialType,
  socialCount,
  showVerification = false,
  className = ''
}) => {
  const getSocialIcon = () => {
    switch (socialType) {
      case 'youtube':
        return <YoutubeIcon className="w-4 h-4 text-red-500" data-id="element-735" />;
      case 'instagram':
        return <InstagramIcon className="w-4 h-4 text-pink-500" data-id="element-736" />;
      case 'twitter':
        return <TwitterIcon className="w-4 h-4 text-blue-400" data-id="element-737" />;
      default:
        return null;
    }
  };
  const highlightText = (text: string) => {
    return text.split(/(\[[^\]]*\])/).map((part, index) => {
      if (part.startsWith('[') && part.endsWith(']')) {
        return <span key={index} className="text-[#00c853] font-semibold" data-id="element-738">
            {part.slice(1, -1)}
          </span>;
      }
      return <span key={index} data-id="element-739">{part}</span>;
    });
  };
  return <div className="flex flex-col items-center h-full max-w-4xl mx-auto px-4" data-id="element-740">
      <div className="flex flex-col items-center justify-center flex-grow" data-id="element-741">
        <div className="mb-8 text-center" data-id="element-742">
          <p className={`text-2xl md:text-3xl text-white leading-relaxed font-light ${className}`} data-id="element-743">
            "{highlightText(quote)}"
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-744">
          <div className="w-20 h-20 relative" data-id="element-745">
            <img src={imageSrc} alt={author} className="w-full h-full rounded-full object-cover border-2 border-dark-500" data-id="element-746" />
            {showVerification && <div className="absolute -bottom-1 -right-1" data-id="element-747">
                <div className="bg-[#3B82F6] rounded-full p-1.5 shadow-lg" data-id="element-748">
                  <CheckIcon className="w-3 h-3 text-white stroke-[3]" data-id="element-749" />
                </div>
              </div>}
          </div>
          {socialCount && socialType && <div className="flex items-center bg-dark-500/50 rounded-full px-3 py-1.5 mt-3 mb-2 backdrop-blur-sm" data-id="element-750">
              {getSocialIcon()}
              <span className="ml-2 text-sm text-white/90" data-id="element-751">{socialCount}</span>
            </div>}
          <div className="text-center" data-id="element-752">
            <h3 className="text-xl text-white font-semibold mb-0.5" data-id="element-753">
              {author}
            </h3>
            <p className="text-sm text-gray-300" data-id="element-754">{position}</p>
          </div>
        </div>
      </div>
    </div>;
};